import { sendEvent } from '@utils/core/track';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import styles from './styles.scss';
interface IProps {
	children: React.ReactNode;
	anchorText: string;
	className?: string;
	eventId?: string;
	onClick?: () => void;
}

function Anchor(props: IProps) {
	const { children, className, anchorText, onClick, eventId } = props;
	const [trigger, setTrigger] = useState<boolean>(false);

	const scrollToAnchor = (anchorName: string) => {
		if (anchorName) {
			const anchorElement = document.getElementById(anchorName);
			if (anchorElement) {
				anchorElement.scrollIntoView({ behavior: 'smooth', block: "end", });
			}
		}
		onClick && onClick();
		eventId && sendEvent({
			eventId: 'ACW_totop',
			eventParam: { trigger_page: eventId }
		})
	}
	useEffect(() => {
		const handleScroll = () => {
			const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
			const scrollHeight = document.getElementById(anchorText) ? document.getElementById?.(anchorText)?.offsetHeight : 0;
			if (scrollHeight && scrollTop > scrollHeight) {
				setTrigger(true);

			} else {
				setTrigger(false);
			}

		}
		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		}
	}, [])

	useEffect(() => {
		if (trigger) {
			sendEvent({
				eventId: 'ACW_scrollonescreen',
			})
		}
	}, [trigger])

	return (
		<div className={classnames(styles['anchor'], className, trigger ? styles.on : styles.off)} onClick={() => scrollToAnchor(anchorText)}>
			{children}
		</div>
	)
}
export default Anchor;
